/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import { useAuth } from '../../modules/auth'
import { TableReportsV2 } from './reportsDetails/TableReportsV2'
import { TableReportsGeneration } from './reportsGeneration/TableReportsGeneration'
import { TableReports } from './reportsDetails/TableReports'
import { TableReportsGenerationV2 } from './reportsDetails/TableReportsGenerationV2'
import useSize from '../../hooks/useSize'

//import { MyPortal } from './components/my-portal'

const reportsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Início',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ReportsPage: FC = () => {
  const user = useAuth();
  const [typeReport, setTypeReport] = useState<string>("GERACAO");
  //const initialHtml = '<h1>Seu HTML inicial aqui...</h1>';

  return (
    <div
      className={`${user.currentUser?.role.slug === "CLIENTE" ? "" : "card"} column g-5 g-xl-8`}
      style={{ height: '100%', minHeight: '60vh' }}
    >
      {user.currentUser?.role.slug === "CLIENTE" ?
        typeReport === "DETALHADO" ?
          <TableReportsV2 
            className='card-xl-stretch mb-xl-8'
            typeReport={typeReport}
            setTypeReport={setTypeReport}
          />
        :
        <TableReportsGenerationV2 
          className='card-xl-stretch mb-xl-8'
          typeReport={typeReport}
          setTypeReport={setTypeReport}
        />
      :
        <div>
          <ul 
            className={`nav nav-stretch nav-line-tabs nav-line-tabs-2x fs-5 fw-bolder flex-nowrap border-bottom border-1 border-muted`} 
            style={{marginLeft: '2rem', marginTop: '1.5rem', marginRight: '2rem'}}
          >
            <li className="nav-item" style={{width: '50%'}}>
              <a
                className="nav-link active bg-active-primary text-active-light text-hover-primary border-hover-primary p-2 rounded"
                data-bs-toggle="tab"
                href="#kt_tab_pane_1"
                style={{width: '100%', display: 'flex', justifyContent: 'center'}}
                //onClick={() => setPages(1)}
              >
                GERAÇÃO
              </a>
            </li>

            <li className="nav-item" style={{width: '50%'}}>
              <a
                className="nav-link bg-active-secondary text-center text-active-light text-hover-secondary border-hover-secondary border-active-secondary p-2 rounded"
                data-bs-toggle="tab"
                href="#kt_tab_pane_3"
                style={{width: '100%', display: 'flex', justifyContent: 'center'}}
                //onClick={() => setPages(3)}
              >
                DETALHADOS
              </a>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane active fade show"
              id="kt_tab_pane_1"
              role="tabpanel"
            >
              <TableReportsGeneration
                className='card-xl-stretch mb-xl-8'
              />
            </div>

            <div className="tab-pane fade" id="kt_tab_pane_3" role="tabpanel">
              <TableReports 
                className='card-xl-stretch mb-xl-8'
              />
            </div>

          </div>
        </div>
      }
      
    </div>
  )
}

const ReportsWrapper: FC = () => {
  const {width} = useSize();

  return (
    <>
      <PageTitle breadcrumbs={reportsBreadcrumbs}>{width < 1200 ? "Meus Relatórios" : "Gerenciamento de Relatórios"}</PageTitle>
      <ReportsPage />
    </>
  )
}

export {ReportsWrapper}

